import * as React from "react";
import { useCallback } from "react";
import { Media } from "components/product-media/media";
import { Header } from "./header";
import { Description } from "./description";
import { SelectedColor } from "components/item/order/selected-color";
import TopProductBadge from "components/insights/badges/top-product-badge";
import type { IBadgeCategories } from "types/insights/product-badges";

interface IProps {
    product: any;
    productViewDef: any;
    scope: any;
    onFetchProduct: (productId: string, force?: boolean) => void;
    twoColumnLayout: boolean;
    productBadges: IBadgeCategories;
}

export const Summary: React.SFC<IProps> = ({
    product,
    productViewDef,
    scope,
    onFetchProduct,
    twoColumnLayout,
    productBadges,
}) => {
    const updateProduct = useCallback(() => onFetchProduct(product._id, true), [onFetchProduct, product]);

    const hasGroupedProducts = scope.brand.hasPreference("group_products");
    if (twoColumnLayout) {
        return (
            <div className="panel summaryColumns">
                <div className="summaryColumn">
                    <Media product={product} scope={scope} updateProduct={updateProduct} />
                </div>
                <div className="summaryColumn">
                    <Header product={product} productViewDef={productViewDef} scope={scope} />
                    {productBadges && <TopProductBadge productBadges={productBadges} />}
                    <Description product={product} />
                    {hasGroupedProducts && <SelectedColor item={product} scope={scope} />}
                </div>
            </div>
        );
    }

    return (
        <div className="panel">
            <Header product={product} productViewDef={productViewDef} scope={scope} />
            {productBadges && <TopProductBadge productBadges={productBadges} />}
            <Media product={product} scope={scope} updateProduct={updateProduct} />
            <Description product={product} />
            {hasGroupedProducts && <SelectedColor item={product} scope={scope} />}
        </div>
    );
};
